class Projection {
  lngLatToPoint() {
    throw new Error('lngLatToPoint方法未实现')
  }

  pointToLngLat() {
    throw new Error('pointToLngLat方法未实现')
  }
}

export default Projection
